import { client } from '../http';

async function moveVariableToFixed(transactionId) {
  return await client.post('/api/investigator/answers/budget-category', { transactionId, budgetCategory: 'fixed' });
}

async function moveVariableToExcluded(transactionId) {
  return await client.post('/api/investigator/answers/budget-category', { transactionId, budgetCategory: 'excluded' });
}

async function moveExcludedToVariable({ transactionId }) {
  return await client.post('/api/investigator/answers/budget-category', { transactionId, budgetCategory: 'variable' });
}

export default {
  async cancelEnvelope({ envelopeId }) {
    return await client.post('/api/prediction-update/cancel-envelope', { envelopeId });
  },
  async updateEnvelopeAmount({ envelopeId, amount }) {
    return await client.post('/api/prediction-update/update-amount', { envelopeId, amount });
  },
  async updateRiseupGoal({ budgetDate, previousAmount, amount }) {
    return await client.post(
      '/api/prediction-update/update-riseup-goal',
      { budgetDate, previousAmount: previousAmount.toString(), amount: amount.toString() },
    );
  },
  async changeCategory({ businessName, transactionId, applyTo, expense }) {
    return await client.post('/api/enrichment-update/save-enrichment', { businessName, transactionId, applyTo, expense });
  },
  async changeTransactionCategory({ trackingCategoryId, matchBy, value }) {
    return client.post('/api/tracking-categories-predicates', {
      trackingCategoryId,
      matchBy,
      value,
    });
  },
  async moveFromTracking({ matchBy, value }) {
    return client.post('/api/tracking-categories-blacklist-predicates', {
      matchBy,
      value,
    });
  },
  async moveVariableExpenseToFixed({ transactionId }) {
    return await moveVariableToFixed(transactionId);
  },
  async moveVariableIncomeToFixed({ transactionId }) {
    return await moveVariableToFixed(transactionId);
  },
  async excludeVariableExpense({ transactionId }) {
    return await moveVariableToExcluded(transactionId);
  },
  async excludeVariableIncome({ transactionId }) {
    return await moveVariableToExcluded(transactionId);
  },
  async moveExcludedToVariableExpense({ transactionId }) {
    return await moveExcludedToVariable({ transactionId });
  },
  async moveExcludedToVariableIncome({ transactionId }) {
    return await moveExcludedToVariable({ transactionId });
  },
  async changeEnvelopeExpenseCategory({ envelopeId, sequenceId, expenseCategory }) {
    return await client.post('/api/prediction-update/envelope-expense-category', { envelopeId, sequenceId, expenseCategory });
  },
};
